(function(){
const root=document.querySelector("[data-scnt-finder]");
if(!root||root.dataset.ready==="1")return;
root.dataset.ready="1";
root.querySelectorAll("[data-mood],[data-family],[data-depth]").forEach(x=>x.setAttribute("aria-pressed","false"));
const status=root.querySelector("[data-finder-status]");
const results=root.querySelector("[data-finder-results]");
const cardBox=root.querySelector("[data-result-cards]");
const summary=root.querySelector("[data-result-summary]");
const findButton=root.querySelector("[data-find-scent]");
let catalog=null;
const moodFamilies={
fresh:["fresh","citrus","aquatic"],
calm:["fresh","aquatic","musky","floral"],
floral:["floral","musky"],
warm:["gourmand","spicy","woody"],
grounded:["woody","oud","spicy"],
playful:["fruity","citrus","gourmand"]
};
const words=["bergamot","grapefruit","lemon","lime","mandarin","orange blossom","orange","neroli","petitgrain","pear","apple","raspberry","blackcurrant","peach","fig","plum","cherry","ginger","cardamom","cinnamon","saffron","clove","pink pepper","black pepper","lavender","rosemary","basil","thyme","mint","jasmine","rose","violet","iris","peony","gardenia","tuberose","lily of the valley","lily","ylang-ylang","sandalwood","cedar","patchouli","vetiver","agarwood","oud","oakmoss","moss","ambergris","amber","musk","vanilla","tonka bean","cacao","chocolate","coffee","caramel","praline","honey","incense","frankincense","myrrh","labdanum","leather","tobacco","sea salt","seaweed","cypress","juniper","davana","elemi","resin","rum","coconut","almond","benzoin","cashmere wood"];
function plain(html){const d=document.createElement("div");d.innerHTML=html||"";return(d.textContent||"").replace(/\s+/g," ").trim()}
function tagsOf(p){const t=Array.isArray(p.tags)?p.tags:String(p.tags||"").split(",");return new Set(t.map(x=>x.trim().toLowerCase()).filter(Boolean))}
function familiesOf(p){const s=tagsOf(p);if(s.has("ouds"))s.add("oud");if(s.has("wood"))s.add("woody");if(s.has("musk"))s.add("musky");return s}
function notesOf(text){
const m=text.match(/(?:top|heart|base)?\s*notes?\s*[:—-]\s*([^.;]{3,180})/i);
if(m){const a=m[1].split(/[,/·]/).map(x=>x.trim()).filter(Boolean);if(a.length)return a.slice(0,6)}
const low=text.toLowerCase(),found=words.filter(w=>low.includes(w));
return found.filter((w,i)=>!found.some((other,j)=>j!==i&&other.length>w.length&&other.includes(w))).slice(0,6)
}
async function load(){
if(catalog)return catalog;
const res=await fetch("/collections/scents/products.json?limit=250",{credentials:"same-origin"});
if(!res.ok)throw new Error("The SCNT fragrance collection could not be loaded. Please refresh and try again.");
const data=await res.json();
catalog=Array.isArray(data.products)?data.products:[];
if(!catalog.length)throw new Error("No fragrances were returned from the SCNT collection.");
return catalog
}
function pressed(attr){const b=root.querySelector("["+attr+"][aria-pressed='true']");return b?b.getAttribute(attr):""}
function score(p,mood,wanted,depth){
const f=familiesOf(p),d=plain(p.body_html||p.description||"").toLowerCase();
let n=0;
(moodFamilies[mood]||[]).forEach(x=>{if(f.has(x))n+=4});
wanted.forEach(x=>{if(f.has(x))n+=5});
const light=["fresh","citrus","aquatic","floral","musky"],rich=["woody","oud","spicy","gourmand"];
if(depth==="light"){if([...f].some(x=>light.includes(x)))n+=2;if([...f].some(x=>rich.includes(x)))n-=1}
if(depth==="rich"){if([...f].some(x=>rich.includes(x)))n+=2;if([...f].some(x=>["citrus","aquatic"].includes(x)))n-=1}
const vocab={fresh:["bright","crisp","vibrant","fresh"],calm:["soft","clean","serene","gentle"],floral:["petal","rose","jasmine","floral"],warm:["warm","vanilla","spice","amber"],grounded:["wood","resin","oud","earthy"],playful:["fruit","juicy","sparkling","sweet"]};
(vocab[mood]||[]).forEach(x=>{if(d.includes(x))n+=.5});
return n
}
function makeCard(p,i){
const desc=plain(p.body_html||p.description||"");
const article=document.createElement("article");article.className="scnt-finder__card";
const a=document.createElement("a");a.className="scnt-finder__card-link";a.href="/products/"+encodeURIComponent(p.handle||"");
const imageWrap=document.createElement("div");imageWrap.className="scnt-finder__card-image";
const image=(p.images&&p.images[0]&&p.images[0].src)||(p.image&&p.image.src);
if(image){const img=document.createElement("img");img.src=image;img.alt=p.title||"SCNT Studio fragrance";img.loading="lazy";imageWrap.appendChild(img)}
a.appendChild(imageWrap);
const body=document.createElement("div");body.className="scnt-finder__card-body";
const rank=document.createElement("div");rank.className="scnt-finder__card-rank";rank.textContent="YOUR MATCH "+String(i+1).padStart(2,"0");
const title=document.createElement("h3");title.className="scnt-finder__card-title";title.textContent=p.title||"SCNT Studio fragrance";
const copy=document.createElement("p");copy.className="scnt-finder__card-description";copy.textContent=desc?(desc.length>190?desc.slice(0,187).trim()+"…":desc):"Explore this composition from the SCNT Studio collection.";
body.append(rank,title,copy);
const notes=notesOf(desc);
if(notes.length){const label=document.createElement("p");label.className="scnt-finder__notes-label";label.textContent="Notes mentioned in description";const list=document.createElement("div");list.className="scnt-finder__notes";notes.forEach(x=>{const chip=document.createElement("span");chip.className="scnt-finder__note";chip.textContent=x;list.appendChild(chip)});body.append(label,list)}
const cta=document.createElement("a");cta.className="scnt-finder__card-cta";cta.href=a.href;cta.textContent="Explore fragrance";cta.setAttribute("aria-label","Explore "+(p.title||"this fragrance"));body.appendChild(cta);
article.append(a,body);return article
}
async function find(){
const mood=pressed("data-mood")||"";
const depth=pressed("data-depth")||"";
const wanted=[...root.querySelectorAll("[data-family][aria-pressed='true']")].map(x=>x.getAttribute("data-family"));
findButton.disabled=true;findButton.innerHTML="CURATING YOUR SCENTS…";status.hidden=true;results.hidden=true;
try{
const all=await load();
const ranked=all.map(p=>({p,s:score(p,mood,wanted,depth)})).sort((a,b)=>b.s-a.s||String(a.p.title).localeCompare(String(b.p.title))).slice(0,3);
cardBox.replaceChildren(...ranked.map((x,i)=>makeCard(x.p,i)));
const labels={fresh:"fresh and uplifting",calm:"calm and serene",floral:"floral and graceful",warm:"warm and cocooning",grounded:"deep and atmospheric",playful:"bright and expressive"};
const preferences=[];
if(mood&&labels[mood])preferences.push("a "+labels[mood]+" atmosphere");
if(wanted.length)preferences.push("an affinity for "+wanted.join(", "));
if(depth)preferences.push("a "+depth+" fragrance presence");
summary.textContent=preferences.length
?"Selected for "+preferences.join(" and ")+". Explore these three compositions as your starting point."
:"No preferences selected — here are three fragrances from the SCNT Studio collection to start exploring.";
results.hidden=false;results.scrollIntoView({behavior:"smooth",block:"start"})
}catch(e){status.textContent=e&&e.message?e.message:"We could not load the fragrances. Please try again.";status.hidden=false}
finally{findButton.disabled=false;findButton.textContent='DISCOVER MY SCENTS'}
}
function reset(){
root.querySelectorAll("[data-mood],[data-family],[data-depth]").forEach(x=>x.setAttribute("aria-pressed","false"));
results.hidden=true;status.hidden=true;
root.querySelector(".scnt-finder__panel").scrollIntoView({behavior:"smooth",block:"start"})
}
root.querySelectorAll("[data-mood],[data-depth],[data-family]").forEach(btn=>btn.addEventListener("click",()=>{
const isFirstQuestion=btn.hasAttribute("data-mood");
const alreadyAnswered=!!root.querySelector("[data-mood][aria-pressed='true']");
if(btn.hasAttribute("data-family"))btn.setAttribute("aria-pressed",btn.getAttribute("aria-pressed")==="true"?"false":"true");
else{const selector=btn.hasAttribute("data-mood")?"[data-mood]":"[data-depth]";root.querySelectorAll(selector).forEach(x=>x.setAttribute("aria-pressed","false"));btn.setAttribute("aria-pressed","true")}
if(isFirstQuestion&&!alreadyAnswered){
const nextQuestion=root.querySelector("[data-question-two]");
if(nextQuestion)requestAnimationFrame(()=>nextQuestion.scrollIntoView({behavior:"smooth",block:"start"}));
}
}));
root.querySelectorAll("[data-reset-scent]").forEach(btn=>btn.addEventListener("click",reset));
findButton.addEventListener("click",find);
})();